import React from 'react'

const Pending = () => {
  return (
    <div>
      <h1>Payment Pending</h1>
      <p>Your payment is being processed. Please wait...</p>    
    </div>
  )
}

export default Pending
